import { isNil } from '@lucidlink/tscore';
import { createAesCrypto } from '#crypto/node-forge';
import { MissingConfigKey, SettingName, SettingTarget } from './types';
export class CommonConfigKeyHelper {
    configManager;
    commonConfigKey;
    aesCrypto = createAesCrypto();
    constructor(configManager, commonConfigKey) {
        this.configManager = configManager;
        this.commonConfigKey = commonConfigKey;
    }
    async encryptCommon(unencrypted, iv) {
        await this.fetchCommonConfigKey();
        return this.aesCrypto.encrypt(unencrypted, this.commonConfigKey, iv);
    }
    async decryptCommon(encrypted, iv) {
        await this.fetchCommonConfigKey();
        return this.aesCrypto.decrypt({ value: encrypted, iv }, this.commonConfigKey);
    }
    async getCommonKey() {
        await this.fetchCommonConfigKey();
        return this.commonConfigKey;
    }
    async fetchCommonConfigKey() {
        if (!isNil(this.commonConfigKey)) {
            return;
        }
        const commonConfigKeyConfig = await this.configManager.get([
            {
                target: SettingTarget.CONFIG_BOOTSTRAP,
                name: SettingName.COMMON_CONFIG_KEY,
            },
        ]);
        const commonConfigKey = commonConfigKeyConfig[0].global();
        if (isNil(commonConfigKey)) {
            throw new MissingConfigKey('Missing common config');
        }
        this.commonConfigKey = commonConfigKey.asBytes();
    }
}
